export default class TranslatedLang {
  /**
   * Extracts translations from window.TYPO3.lang and stores them
   * under a freely chosen object key (default: "csConfig").
   *
   * @param {string}  configKey   Prefix of the language keys, e.g. "splide"
   * @param {string}  objectName  Name of the returned object key, default "csConfig"
   * @returns {Object}            e.g. { config: { arrowNext: "Weiter", … } }
   */
  static translatedLangConfig(configKey = '', objectName = 'csConfig') {
    // Punkt automatisch anhängen, damit "splide" → "splide."
    const prefix = configKey.endsWith('.') ? configKey : `${configKey}.`;

    const src = window?.TYPO3?.lang ?? {};
    const translations = {};

    for (const [key, value] of Object.entries(src)) {
      if (key.startsWith(prefix)) {
        const prop = key.slice(prefix.length); // Präfix + Punkt abschneiden
        translations[prop] = value;
      }
    }

    return { [objectName]: translations };
  }
}
